import { createSlice } from "@reduxjs/toolkit";

export const transferSlice = createSlice({
  name: "transfer",
  initialState: {
    isTransferring: false,
    message: "",
    error: null,
    success: false,
  },
  reducers: {
    transfer: (state) => {
      state.isTransferring = true;
      state.message = "";
      state.error = null;
      state.success = false;
    },
    setTransfer: (state, { payload }) => {
      state.isTransferring = false;
      state.message = payload.message;
      state.success = payload.success === true;
      state.error = null;
    },
    transferError: (state, { payload }) => {
      state.isTransferring = false;
      state.error = payload.error;
      state.success = false;
    },
  },
});

export const { transfer, setTransfer, transferError } = transferSlice.actions;
export default transferSlice.reducer;
